export default {
    getEventList (state) {
        return state.eventList
    },
    getMainEvent (state) {
        return state.mainEvent
    },
    getTalkEvents (state) {
        return state.talkEvents
    },
    getLiveEvents (state) {
        return state.liveEvents
    },
    getLiveExperts (state) {
        return state.expertsLive
    },
    getTalkExperts (state) {
        return state.expertsTalk
    },
    getUserEvents (state) {
        return state.userEvents
    },
    getSelectedEvent (state) {
        return state.selectedEvent
    },
    getEventUsers (state) {
        return state.eventUsers
    },
    getUserSignature (state) {
        return state.userSig
    },
    getUnauthUserSignature (state) {
        return state.unAuthUserSig
    },
    getDemoUserStatus (state) {
        return state.demoUserStatus
    },
    getUserStatus (state) {
        return state.isUserAnonymous
    },
    getBannerEvent (state) {
        return state.bannerEvent
    },
    getLiveEventsArchive (state) {
        return state.liveEventsArchive
    },
    getArchivePlaylist (state) {
        return state.archivePlaylist
    },
    getMonthEvents (state) {
        return state.monthEvents
    },
    getCorpPrivateEvents (state) {
        return state.corpPrivateEvents
    },
    getCorpPublicEvents (state) {
        return state.corpPublicEvents
    },
    getCorpAllEvents (state) {
        return state.corpAllEvents
    },
    getCorpMainEvent (state) {
        return state.corpMainEvent
    },
    getCorpArchiveEvents (state) {
        return state.corpArchiveEvents
    },
    getCorpPlaylists (state) {
        return state.corpPlaylists
    },
    getDemoEvent (state) {
        return state.demoEvent
    },
    getCorpPrivateVideos (state) {
        return state.corpPrivateVideos
    },
    getUpcomingEvent (state) {
        return state.upcomingEvent
    }
}



// WEBPACK FOOTER //
// ./src/store/events/getters.js